export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'action', name: '热血', icon: 'ri-fire-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'school', name: '校园', icon: 'ri-building-line' },
  { slug: 'bl', name: '耽美', icon: 'ri-star-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
];

export const comics = [
  {
    id: 1,
    title: '社内恋爱法则',
    author: '李智恩',
    category: 'romance',
    description: '新入职的实习生林小婉被分配到公司最严格的部门经理手下，原以为会是一场职场噩梦，却意外发现这位冷面上司私下里有着不为人知的温柔一面。两人在办公室的朝夕相处中，一段甜蜜又刺激的办公室恋情悄然展开……',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20office%20romance%20between%20handsome%20male%20boss%20and%20beautiful%20female%20employee%2C%20soft%20romantic%20illustration%20style%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20anime%20art&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    rating: 4.8,
    views: 1285000,
    chapters: 67,
    status: 'ongoing',
    updateTime: '2026-08-03',
    tags: ['恋爱', '职场', '甜宠', '都市'],
    featured: true,
  },
  {
    id: 2,
    title: '剑与魔法之王',
    author: '金泰亨',
    category: 'fantasy',
    description: '平凡的高中生韩俊昊在一次意外中穿越到了魔法与剑术并存的异世界。在这个强者为尊的世界里，他从一无所有的异乡人开始，凭借着不屈的意志和过人的天赋，一步步走向巅峰，成为令整个大陆为之颤抖的剑与魔法之王。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20fantasy%20adventure%20male%20warrior%20with%20sword%20and%20magic%20in%20epic%20landscape%2C%20dramatic%20illustration%20style%2C%20golden%20hour%20lighting%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    rating: 4.9,
    views: 2150000,
    chapters: 124,
    status: 'ongoing',
    updateTime: '2026-08-04',
    tags: ['奇幻', '冒险', '战斗', '成长'],
    featured: true,
  },
  {
    id: 3,
    title: '甜蜜的谎言',
    author: '朴秀敏',
    category: 'drama',
    description: '为了偿还家庭债务，女大学生韩素希不得不与财阀二代签订了一份假结婚协议。原本以为只是一场各取所需的交易，却在日复一日的相处中，两人的心渐渐靠近。然而当真相浮出水面时，这份建立在谎言上的感情能否经受住考验？',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20romantic%20drama%20elegant%20couple%20in%20wedding%20theme%2C%20emotional%20illustration%20style%2C%20soft%20pastel%20tones%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    rating: 4.7,
    views: 1890000,
    chapters: 89,
    status: 'ongoing',
    updateTime: '2026-08-02',
    tags: ['爱情', '契约婚姻', '财阀', '虐心'],
    featured: true,
  },
  {
    id: 4,
    title: '校园王牌特工',
    author: '崔珉豪',
    category: 'action',
    description: '表面上是一名普通高中生的金志勋，实际上是国家秘密组织培养的王牌特工。白天他在教室里应付考试，夜晚则穿梭于城市暗处执行危险任务。当校园生活和秘密使命发生冲突时，他必须学会在双重身份之间找到平衡。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20action%20high%20school%20student%20secret%20agent%20with%20cool%20pose%2C%20dynamic%20illustration%20style%2C%20urban%20night%20vibe%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    rating: 4.6,
    views: 1560000,
    chapters: 95,
    status: 'ongoing',
    updateTime: '2026-08-04',
    tags: ['动作', '校园', '特工', '热血'],
    featured: true,
  },
  {
    id: 5,
    title: '重生之影后归来',
    author: '崔雪莉',
    category: 'drama',
    description: '前世被最信任的人背叛，当红影后沈清妍含恨而终。一朝重生回到出道前的素人时期，她带着前世的记忆和演技，发誓要让所有伤害过她的人付出代价。这一次，她要站上比前世更高的巅峰，成为无人能及的王牌影后。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20glamorous%20actress%20revenge%20story%2C%20elegant%20and%20dramatic%20illustration%20style%2C%20red%20carpet%20vibe%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    rating: 4.8,
    views: 2320000,
    chapters: 112,
    status: 'ongoing',
    updateTime: '2026-08-03',
    tags: ['重生', '娱乐圈', '复仇', '逆袭'],
    featured: true,
  },
  {
    id: 6,
    title: '猫咪咖啡厅',
    author: '金多美',
    category: 'comedy',
    description: '失业青年张明浩在偶然的机会下接手了一家濒临倒闭的猫咪咖啡厅。原本对猫一窍不通的他，在五只性格迥异的猫咪和一群可爱的同事们的帮助下，开始了啼笑皆非的创业之路。温馨搞笑的日常，治愈每一个疲惫的心灵。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20cute%20cat%20cafe%20comedy%20with%20adorable%20cats%20and%20young%20owner%2C%20playful%20illustration%20style%2C%20warm%20cozy%20colors%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    rating: 4.5,
    views: 980000,
    chapters: 56,
    status: 'ongoing',
    updateTime: '2026-08-01',
    tags: ['搞笑', '日常', '治愈', '萌宠'],
    featured: false,
  },
  {
    id: 7,
    title: '暗夜追踪者',
    author: '郑宇成',
    category: 'thriller',
    description: '连环杀人案打破了宁静小镇的平和。刑警姜道贤在追查案件的过程中，发现每一个受害者都与十年前的某起悬案有着千丝万缕的联系。随着调查深入，一个隐藏在黑暗中的庞大犯罪网络逐渐浮出水面，而真相远比想象的更加残酷。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20dark%20thriller%20detective%20investigating%20crime%20scene%2C%20mysterious%20noir%20illustration%20style%2C%20nighttime%20urban%20atmosphere%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    rating: 4.7,
    views: 1750000,
    chapters: 78,
    status: 'ongoing',
    updateTime: '2026-08-03',
    tags: ['悬疑', '刑侦', '犯罪', '推理'],
    featured: true,
  },
  {
    id: 8,
    title: '我的同桌是校霸',
    author: '韩素媛',
    category: 'school',
    description: '学霸班长林雨桐被班主任安排与全校闻名的校霸陈墨做同桌，美其名曰"互帮互助"。一个是品学兼优的三好学生，一个是让老师头疼的问题少年，两个看似水火不容的人，在一张课桌的距离中，擦出了意想不到的火花。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20high%20school%20romance%20between%20studious%20girl%20and%20rebellious%20boy%20deskmates%2C%20youthful%20illustration%20style%2C%20bright%20classroom%20setting%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    rating: 4.6,
    views: 1430000,
    chapters: 72,
    status: 'ongoing',
    updateTime: '2026-08-04',
    tags: ['校园', '恋爱', '青春', '甜宠'],
    featured: false,
  },
  {
    id: 9,
    title: '星之彼方',
    author: '姜东元',
    category: 'bl',
    description: '天文系研究生沈星辰在一次野外观测中，意外发现了来自外星的信号。与此同时，一个自称来自"星之彼方"的神秘男子出现在他的生活中。跨越星际的相遇，两个灵魂在浩瀚宇宙中找到了彼此的归宿。一段超越世俗的浪漫星际之恋。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20beautiful%20romantic%20BL%20story%20with%20starry%20night%20sky%20and%20two%20young%20men%2C%20dreamy%20illustration%20style%2C%20cosmic%20purple%20blue%20tones%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    rating: 4.9,
    views: 1980000,
    chapters: 86,
    status: 'ongoing',
    updateTime: '2026-08-03',
    tags: ['耽美', '科幻', '浪漫', '星际'],
    featured: true,
  },
  {
    id: 10,
    title: '小确幸日记',
    author: '尹智秀',
    category: 'daily',
    description: '刚毕业的社畜金多喜在繁忙的都市生活中，努力寻找属于自己的小确幸。从学会做一道新菜，到在雨天偶遇一只流浪猫，再到和邻居大叔成为忘年交——生活虽然平凡，但每一天都有值得珍藏的美好瞬间。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20slice%20of%20life%20young%20woman%20enjoying%20daily%20moments%2C%20heartwarming%20illustration%20style%2C%20soft%20daylight%20colors%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-10&orientation=portrait',
    rating: 4.4,
    views: 820000,
    chapters: 48,
    status: 'ongoing',
    updateTime: '2026-08-02',
    tags: ['日常', '治愈', '生活', '温馨'],
    featured: false,
  },
  {
    id: 11,
    title: '总裁的契约新娘',
    author: '宋慧乔',
    category: 'romance',
    description: '为了拯救家族企业，温柔善良的珠宝设计师顾清漪被迫与冷酷无情的商业帝王厉爵风签订了一份为期三年的婚姻契约。她以为这只是一场冰冷的交易，却不知厉爵风早已暗恋她多年，这场契约婚姻不过是他精心策划的一场温柔陷阱。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20elegant%20romance%20between%20CEO%20and%20beautiful%20woman%20in%20luxurious%20setting%2C%20sophisticated%20illustration%20style%2C%20warm%20golden%20lighting%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-11&orientation=portrait',
    rating: 4.7,
    views: 1650000,
    chapters: 81,
    status: 'ongoing',
    updateTime: '2026-08-04',
    tags: ['恋爱', '总裁', '契约', '甜宠'],
    featured: false,
  },
  {
    id: 12,
    title: '热血格斗王',
    author: '李敏镐',
    category: 'action',
    description: '从小在街头长大的孤儿秦风，凭借一双铁拳在地下格斗场打出了名堂。当国际格斗大赛的机会降临，他决定走出黑暗，站上世界舞台。然而曾经的仇家不会轻易放过他，赛场内外都充满了致命的挑战。用拳头打出一条通往光明的路！',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20intense%20fighting%20action%20male%20fighter%20in%20boxing%20ring%2C%20powerful%20dynamic%20illustration%20style%2C%20dramatic%20lighting%2C%20clean%20simple%20background&width=800&height=1120&seq=comic-cover-12&orientation=portrait',
    rating: 4.8,
    views: 1870000,
    chapters: 103,
    status: 'ongoing',
    updateTime: '2026-08-03',
    tags: ['格斗', '热血', '竞技', '成长'],
    featured: false,
  },
];

export const chapterData: Record<number, { id: number; title: string; updateTime: string }[]> = {
  1: [
    { id: 1, title: '第1话 新的开始', updateTime: '2026-01-15' },
    { id: 2, title: '第2话 初次见面', updateTime: '2026-01-22' },
    { id: 3, title: '第3话 办公室的秘密', updateTime: '2026-01-29' },
    { id: 4, title: '第4话 意外的加班', updateTime: '2026-02-05' },
    { id: 5, title: '第5话 雨中的温暖', updateTime: '2026-02-12' },
    { id: 6, title: '第6话 心跳加速', updateTime: '2026-02-19' },
    { id: 7, title: '第7话 误会', updateTime: '2026-02-26' },
    { id: 8, title: '第8话 真心话', updateTime: '2026-03-05' },
  ],
  2: [
    { id: 1, title: '第1话 异世界的召唤', updateTime: '2025-06-01' },
    { id: 2, title: '第2话 初识魔法', updateTime: '2025-06-08' },
    { id: 3, title: '第3话 第一次战斗', updateTime: '2025-06-15' },
    { id: 4, title: '第4话 同伴集结', updateTime: '2025-06-22' },
    { id: 5, title: '第5话 魔龙之谷', updateTime: '2025-06-29' },
    { id: 6, title: '第6话 觉醒之力', updateTime: '2025-07-06' },
    { id: 7, title: '第7话 王都的阴谋', updateTime: '2025-07-13' },
    { id: 8, title: '第8话 决战的钟声', updateTime: '2025-07-20' },
  ],
};

export const testimonials = [
  {
    id: 1,
    name: '小丸子',
    avatar: '',
    content: '韩漫之家真的是我每天都在用的宝藏网站！下拉式阅读太方便了，加载速度也超级快，再也不用一页一页点来点去了。漫画资源也很全，我想看的韩漫基本都能找到。',
    rating: 5,
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '漫画控阿杰',
    avatar: '',
    content: '作为一个看了十年漫画的老读者，韩漫之家的阅读体验是我用过最好的。智能加载技术让阅读非常流畅，而且分类很清晰，找漫画特别方便。强烈推荐给所有韩漫爱好者！',
    rating: 5,
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '夜雨声烦',
    avatar: '',
    content: '之前一直在找好用的韩漫网站，试了好几个都不太满意。偶然发现了韩漫之家，直接被圈粉！界面简洁大方，漫画更新也很快，每天刷新都有新内容看，太幸福了。',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 4,
    name: '柠檬不酸',
    avatar: '',
    content: '韩漫之家的下拉式阅读模式真的是懒人福音！躺着看漫画再也不用频繁翻页了，而且图片清晰度很高。就是希望耽美分类可以再多一些漫画，其他方面都非常满意。',
    rating: 5,
    date: '2026-07-18',
  },
  {
    id: 5,
    name: '风中的蒲公英',
    avatar: '',
    content: '朋友推荐的韩漫之家，用了之后发现真的很好用。更新速度很快，热门漫画基本同步更新。阅读界面也很舒适，长时间看也不会觉得眼睛累。已经安利给身边所有喜欢看韩漫的朋友了！',
    rating: 5,
    date: '2026-07-15',
  },
  {
    id: 6,
    name: '追漫小达人',
    avatar: '',
    content: '韩漫之家的漫画质量很高，翻译也很用心。特别喜欢她们的分类功能，可以根据自己的喜好快速找到想看的漫画。而且网站没有任何烦人的弹窗广告，阅读体验一级棒！',
    rating: 5,
    date: '2026-07-10',
  },
];

export const faqs = [
  {
    question: '韩漫之家是完全免费的吗？',
    answer: '是的，韩漫之家所有漫画资源均免费向用户开放，无需付费即可享受完整的在线阅读体验。我们致力于为韩漫爱好者提供最优质的免费阅读服务。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是韩漫之家独有的阅读模式，您只需向下滑动页面即可连续阅读，无需点击翻页按钮。配合智能加载技术，系统会提前预加载后续内容，确保阅读过程流畅无卡顿。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '韩漫之家与多家韩漫版权方保持密切合作，热门漫画基本可以实现与韩国同步更新。一般工作日内每日都有新内容上架，周末也会有精选漫画更新。',
  },
  {
    question: '支持手机端阅读吗？',
    answer: '韩漫之家采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备访问，都能获得流畅舒适的下拉式阅读体验。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过网站顶部的搜索框输入漫画名称或作者名进行搜索，也可以通过分类导航按类型筛选感兴趣的漫画。我们还提供了热门标签功能，帮助您快速发现好漫画。',
  },
  {
    question: '遇到加载问题怎么办？',
    answer: '如果您在使用过程中遇到加载缓慢或无法显示的问题，建议检查网络连接状态，或尝试刷新页面。如问题持续存在，可以通过关于我们页面的联系方式向我们反馈，我们会尽快处理。',
  },
];